import React from 'react';
import { Helmet } from 'react-helmet-async';
import Hero from '../../components/Hero';
import CallToAction from '../../components/CallToAction';
import './ProjectPage.css';

// Import images
import softwareHeroImage from '../../assets/images/software.jpg';

const MobileWeb = () => {
  return (
    <div className="project-page">
      <Helmet>
        <title>Mobil ve Web Uygulamaları | Dijital Dönüşüm Çözümleri - ProgenX 2024</title>
        <meta name="description" content="ProgenX mobil ve web uygulama geliştirme hizmetleri. iPhone, Android ve web için kullanıcı dostu, hızlı ve güvenilir uygulamalar. İşletmenizi dijital dünyaya taşıyın. Türkiye'nin önde gelen yazılım geliştirme şirketi." />
        <meta name="keywords" content="mobil uygulama geliştirme, web uygulama geliştirme, ios uygulama, android uygulama, dijital dönüşüm, yazılım çözümleri, iş süreçleri dijitalleştirme, türkiye yazılım şirketi, mobil app geliştirme" />
        <meta property="og:title" content="Mobil ve Web Uygulamaları | ProgenX" />
        <meta property="og:description" content="Müşterilerinize her yerden erişim sağlayan mobil ve web uygulamaları geliştiriyoruz." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://progenxacademy.com/projeler/mobil-web-uygulamalari" />
        <link rel="canonical" href="https://progenxacademy.com/projeler/mobil-web-uygulamalari" />
      </Helmet>

      <Hero 
        title="Mobil ve Web Uygulamaları" 
        backgroundImage={softwareHeroImage}
      />

      <div className="project-content">
        <div className="container">
          <section className="project-overview">
            <h2>İşletmenizi Dijital Dünyaya Taşıyoruz</h2>
            <p>
              Müşterileriniz artık her yerde. Telefonlarında, tabletlerinde, bilgisayarlarında. 
              ProgenX olarak, işletmenizin bu dijital dünyada güçlü bir şekilde var olmasını sağlıyoruz. 
              Kullanıcı dostu, hızlı ve güvenilir mobil ve web uygulamaları geliştirerek, 
              müşterilerinize en iyi deneyimi sunmanıza yardımcı oluyoruz.
            </p>
          </section>

          <section className="project-features">
            <h3>Ne Tür Uygulamalar Geliştiriyoruz?</h3>
            <div className="features-grid">
              <div className="feature-item">
                <h4>Mobil Uygulamalar</h4>
                <p>
                  iPhone ve Android telefonlar için uygulamalar geliştiriyoruz. Müşterileriniz 
                  işletmenize her yerden, her zaman erişebilir. Tek bir uygulama ile hem iOS hem 
                  Android'de çalışan çözümler sunuyoruz.
                </p>
              </div>

              <div className="feature-item">
                <h4>Web Uygulamaları</h4>
                <p>
                  İşletmenizin ihtiyaçlarına özel web uygulamaları geliştiriyoruz. E-ticaret 
                  sitelerinden, içerik yönetim sistemlerine, müşteri portallarından iş uygulamalarına 
                  kadar geniş bir yelpazede çözümler sunuyoruz.
                </p>
              </div>

              <div className="feature-item">
                <h4>Kullanıcı Deneyimi Odaklı Tasarım</h4>
                <p>
                  Uygulamalarımız sadece çalışmaz, aynı zamanda kullanımı kolay ve keyifli olur. 
                  Müşterilerinizin ne istediğini anlayarak, onların ihtiyaçlarına göre tasarlıyoruz. 
                  Böylece müşteri memnuniyeti artar.
                </p>
              </div>

              <div className="feature-item">
                <h4>Güvenilir ve Hızlı Çözümler</h4>
                <p>
                  Uygulamalarımız hızlı yüklenir, güvenli çalışır ve büyüdükçe büyür. Müşteri 
                  sayınız arttıkça uygulamanız da büyür. Performans testleri, güvenlik kontrolleri 
                  ve sürekli güncellemelerle uygulamanız her zaman en iyi durumda kalır.
                </p>
              </div>
            </div>
          </section>

          <section className="project-benefits">
            <h3>İşletmeniz İçin Ne Sağlıyoruz?</h3>
            <div className="benefits-grid">
              <div className="benefit-item">
                <h4>Müşterilerinize Her Yerden Erişim</h4>
                <p>Mobil ve web uygulamalarımız sayesinde müşterileriniz işletmenize istediği 
                yerden, istediği zaman erişebilir. Bu da daha fazla müşteri ve daha fazla satış demek.</p>
              </div>
              <div className="benefit-item">
                <h4>Kolay Kullanım, Mutlu Müşteriler</h4>
                <p>Uygulamalarımız kullanımı kolaydır. Müşterileriniz ne yapmak istediklerini 
                kolayca bulur, hızlıca işlemlerini tamamlar. Bu da memnuniyeti artırır.</p>
              </div>
              <div className="benefit-item">
                <h4>Hızlı ve Verimli Geliştirme</h4>
                <p>Projelerinizi hızlı bir şekilde hayata geçiriyoruz. İşletmeniz dijital 
                dünyada varlığını kısa sürede göstermeye başlar.</p>
              </div>
              <div className="benefit-item">
                <h4>Her Zaman Yanınızdayız</h4>
                <p>Uygulamanız hazır olduktan sonra da yanınızdayız. Güncellemeler, bakım, 
                destek - her zaman uygulamanızın en iyi durumda olmasını sağlıyoruz.</p>
              </div>
            </div>
          </section>
        </div>
      </div>

      <CallToAction 
        title="Dijital Dünyada Güçlü Bir Varlık Olun"
        subtitle="Mobil ve web uygulamalarıyla müşterilerinize her yerden erişim sağlayın."
        buttonText="Proje Teklifi Alın" 
        buttonLink="/iletisim" 
      />
    </div>
  );
};

export default MobileWeb; 